import type { FC } from 'react';
import { Box, Grid, } from '@material-ui/core';
import CurvaProduccionTable from './CurvaProduccionTable';
import CurvaProduccionChartLine from './CurvaProduccionChartLine';
import CurvaProduccionChartBarLine from './CurvaProduccionChartBarLine';

const CurvaProduccionDesembolso: FC<{ headers: any[], data: any }> = ({ headers, data }) => (
  <>
    <Box p={0}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <CurvaProduccionTable data={data} headers={headers} />
        </Grid>
        <Grid item xs={12} md={6}>
          <CurvaProduccionChartLine data={data} headers={headers} title="Real Acum. Vs Fcst Acum." />
        </Grid>
        <Grid item xs={12} md={6}>
          <CurvaProduccionChartBarLine data={data} headers={headers} title="Desembolsos: #Operaciones" />
        </Grid>
      </Grid>
    </Box>
  </>
);

export default CurvaProduccionDesembolso;
